import en from 'i18n/job_profile_skills.en.json'
import nb from 'i18n/job_profile_skills.nb.json'

import { t } from 'ttag'

const languages = { en, nb }

export const getExplanations = (categoryKeys, language) =>
  categoryKeys.map(key => languages[language][key]['explanation'])

export const getSkillTraitTranslations = label => {
  const skillTraitTranslations = {
    Extraversion: t`Extraversion`,
    GMA: t`GMA`,
    Agreeableness: t`Agreeableness`,
    Conscientiousness: t`Conscientiousness`,
    Hardiness: t`Hardiness`,
    Reliability: t`Integrity`,
    ['Emotional Stability']: t`Emotional Stability`,
    ['Openness to Experience']: t`Openness to Experience`,
    ['PA']: t`Positive Affectivity`,
  }

  return skillTraitTranslations[label]
}

export const skillTraitMapping = {
  leadership: ['Extraversion', 'GMA'],
  teams: ['Extraversion', 'Agreeableness'],
  mentoring: ['Agreeableness', 'Conscientiousness', 'GMA'],
  decide: ['Extraversion', 'Hardiness'],
  present: ['Extraversion', 'Emotional Stability'],
  convince: ['Agreeableness', 'GMA'],
  relationships: ['Extraversion', 'Agreeableness', 'Openness to Experience'],
  sociability: ['Extraversion', 'Openness to Experience'],
  helpfulness: ['Agreeableness'],
  cooperate: ['Agreeableness'],
  integrity: ['Agreeableness', 'Reliability'],
  initiative: ['Conscientiousness', 'Hardiness'],
  detailed: ['Conscientiousness'],
  reliability: ['Conscientiousness', 'Reliability'],
  organize: ['Conscientiousness'],
  independence: ['Conscientiousness'],
  customers: ['Conscientiousness', 'Emotional Stability'],
  stress: ['Emotional Stability', 'Hardiness'],
  persistence: ['PA', 'Hardiness'],
  control: ['Emotional Stability', 'PA'],
  flexibility: [
    'Openness to Experience',
    'Emotional Stability',
    'PA',
  ],
  innovation: ['Openness to Experience'],
  learn: ['Openness to Experience'],
  strategies: ['Openness to Experience', 'Conscientiousness', 'GMA'],
  analytical: ['GMA'],
  expertise: ['GMA'],
}
